import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-table"
}
const _hoisted_2 = { class: "el-table__cell" }
const _hoisted_3 = { class: "cell" }
const _hoisted_4 = { class: "el-table__cell" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "el-table__cell" }
const _hoisted_7 = { class: "cell" }
const _hoisted_8 = {
  key: 0,
  class: "el-table__cell"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "el-table__cell" }
const _hoisted_11 = { class: "cell" }
const _hoisted_12 = { class: "el-table__cell" }
const _hoisted_13 = { class: "cell" }
const _hoisted_14 = { class: "el-table__cell" }
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "cell" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_19 = { class: "visiting-companies__editor-row" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "el-table__cell" }
const _hoisted_22 = { class: "cell" }
const _hoisted_23 = { class: "el-table__cell" }
const _hoisted_24 = { class: "cell" }
const _hoisted_25 = { class: "el-table__cell" }
const _hoisted_26 = { class: "cell" }
const _hoisted_27 = { class: "el-table__cell" }
const _hoisted_28 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "personForm",
    class: "contact-persons",
    "label-position": "top",
    model: _ctx.personModel
  }, {
    default: _withCtx(() => [
      (_ctx.mode !== 'view' || _ctx.model.contactPersons.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.trans("label.contact-person")), 1)
                ]),
                _createElementVNode("th", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.trans("label.contact-no")), 1)
                ]),
                _createElementVNode("th", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.trans("label.contact-email")), 1)
                ]),
                (_ctx.mode !== 'view')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.contactPersons, (person, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (!person.deleted)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(person.contactPerson), 1)
                        ]),
                        _createElementVNode("td", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(person.contactNo), 1)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(person.contactEmail), 1)
                        ]),
                        (_ctx.mode !== 'view')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.removeContactPerson(index))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _createElementVNode("tbody", _hoisted_19, [
              (_ctx.mode !== 'view')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_form_item, {
                          prop: "contactPerson",
                          rules: {
										required: true,
										message: _ctx.trans(
											'message.field_require',
											_ctx.trans('label.contact-person')
										)
									}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.personModel.contactPerson,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personModel.contactPerson) = $event)),
                              size: "small",
                              maxlength: "50",
                              "show-word-limit": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_el_form_item, {
                          prop: "contactNo",
                          rules: {
										required: true,
										message: _ctx.trans(
											'message.field_require',
											_ctx.trans('label.contact-no')
										)
									}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.personModel.contactNo,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.personModel.contactNo) = $event)),
                              size: "small",
                              maxlength: "20",
                              "show-word-limit": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_el_form_item, {
                          prop: "contactEmail",
                          rules: {
										type: 'email',
										required: true,
										message: _ctx.trans(
											'message.field_not-email',
											_ctx.trans('label.contact-email')
										)
									}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.personModel.contactEmail,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personModel.contactEmail) = $event)),
                              size: "small",
                              maxlength: "200",
                              "show-word-limit": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "small",
                              onClick: _ctx.addContactPerson
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.trans("label.add")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model"]))
}